import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const assetsDashboardsDetailRoute: InvariantJiraRoute = {
	name: 'assets-dashboards-detail',
	path: '/jira/assets/dashboards/:templateId',
	exact: true,
};
